import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { APP } from '../tokens';

interface MobileSidebarDrawerProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}

export default function MobileSidebarDrawer({ open, onClose, children }: MobileSidebarDrawerProps) {
  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [open, onClose]);

  return (
    <div
      aria-hidden={!open}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 12000,
        pointerEvents: open ? 'auto' : 'none',
      }}
    >
      <button
        type="button"
        aria-label="Close navigation"
        onClick={onClose}
        style={{
          position: 'absolute',
          inset: 0,
          border: 'none',
          background: 'rgba(22, 17, 13, 0.42)',
          opacity: open ? 1 : 0,
          transition: 'opacity 180ms ease',
        }}
      />
      <aside
        role="dialog"
        aria-modal="true"
        aria-label="Navigation"
        style={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          width: 'min(86vw, 336px)',
          maxWidth: '100vw',
          overflow: 'hidden',
          background: APP.bgSidebar,
          boxShadow: '18px 0 40px rgba(22, 17, 13, 0.28)',
          transform: open ? 'translateX(0)' : 'translateX(-104%)',
          transition: 'transform 220ms ease',
        }}
      >
        {children}
      </aside>
    </div>
  );
}
